import { render, staticRenderFns } from "./EventsBiddingList.vue?vue&type=template&id=a1e9d596&scoped=true"
import script from "./EventsBiddingList.vue?vue&type=script&lang=js"
export * from "./EventsBiddingList.vue?vue&type=script&lang=js"
import style0 from "./EventsBiddingList.vue?vue&type=style&index=0&id=a1e9d596&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e9d596",
  null
  
)

export default component.exports